module.exports = __webpack_public_path__ + "static/media/EDIT 2.fc779b1d.JPG";